//
// Copyright 2025 DXOS.org
//

import { DxTagPickerItem, type DxTagPickerItemProps } from '@dxos/lit-ui/react';

export const TagPickerItem = DxTagPickerItem;

export type TagPickerItemProps = DxTagPickerItemProps;
